export default {
  profile: '/profile'
};
